import React, { FC, ReactNode, Suspense } from 'react';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';

import { FullPageLoader } from '../components/FullPageLoader';

/**
 * Wraps the {children} in an ErrorBoundary and Suspense container for future
 * / async loaded bundles.
 * @param children
 */
export const BoundaryWrapper: FC<BoundaryWrapperProps> = ({ children }) => (
  <SentryBoundary>
    <Suspense fallback={<FullPageLoader />}>
      {children}
    </Suspense>
  </SentryBoundary>
);

export interface BoundaryWrapperProps {
  children: ReactNode;
}
